// What the recordings table shows for a recording doc. The doc's `status`
// moves pending → processing → processed, or ends in upload_failed / error:
//   pending        doc created, the browser is still uploading the video
//   processing     onRecordingUploaded split it; chunks are being analysed
//   processed      done (older docs say "transcribed")
//   upload_failed  the upload died (the page caught it, or sweepStuckRecordings
//                  found the doc still pending hours later with no video)
//   error          processing gave up; `error` says which rerun to use
export function recordingStatus(rec) {
  const status = rec?.status;
  if (status === "processed" || status === "transcribed") {
    return { key: "transcribed", label: "Transcribed", hint: "" };
  }
  if (status === "upload_failed") {
    return {
      key: "failed",
      label: "Upload failed",
      hint:
        rec.error ||
        "The upload never finished. Delete this recording and upload it again.",
    };
  }
  if (status === "error") {
    return {
      key: "failed",
      label: "Failed",
      hint: rec.error || "Processing failed. Try one of the rerun options.",
    };
  }
  if (status === "pending") {
    return {
      key: "uploading",
      label: "Uploading",
      hint: "The recording is still uploading. Keep the uploading tab open until it finishes.",
    };
  }
  return { key: "processing", label: "Processing", hint: "" };
}

// The sub-label under the "Total recordings" tile, e.g. "2 failed · 3 processing".
export function recordingsSummary(recordings) {
  if (!recordings.length) return "—";
  const counts = { failed: 0, uploading: 0, processing: 0 };
  recordings.forEach((r) => {
    const { key } = recordingStatus(r);
    if (key in counts) counts[key]++;
  });
  const parts = Object.entries(counts)
    .filter(([, n]) => n > 0)
    .map(([key, n]) => `${n} ${key}`);
  return parts.length ? parts.join(" · ") : "all transcribed";
}
